import React from 'react';
import { createRoot } from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import './utils/colors.scss';
import './utils/utils.scss';
import './app/layout.scss';
import './styles/antd-modals.scss';
import './styles/table.scss';
import './styles/disabled-fields.scss';
import App from './app/App';

const originalWarn = console.warn;

console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('findDOMNode is deprecated')) {
    return;
  }
};

console.warn = (...args) => {
  if (typeof args[0] === 'string' && 
      (args[0].includes('findDOMNode is deprecated') || 
       args[0].includes('childContextTypes') ||
       args[0].includes('legacy childContextTypes'))) {
    return;
  }
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
